import { render, staticRenderFns } from "./village-passport-modal.vue?vue&type=template&id=15097bd7&scoped=true&"
import script from "./village-passport-modal.vue?vue&type=script&lang=ts&"
export * from "./village-passport-modal.vue?vue&type=script&lang=ts&"
import style0 from "./village-passport-modal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./village-passport-modal.vue?vue&type=style&index=1&id=15097bd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15097bd7",
  null
  
)

export default component.exports